export default class BotonInicio {
    constructor(boton) {
        this.boton = boton;
        this.configurar();
    }

    configurar() {
        this.irArriba = this.botonClickCallback();
        this.evaluarDespliegue = this.windowScrollCallback();
        this.evaluarClaseEnBoton();
        this.boton.addEventListener("click", this.irArriba);
        window.addEventListener("scroll", this.evaluarDespliegue, {passive: true});
    }

    evaluarClaseEnBoton() {
        const {clientHeight: altoDocumento} = document.documentElement,
        {innerHeight: altoVentana, scrollY} = window;

        if (altoDocumento > 1.5 * altoVentana) {
            this.boton.classList.add("no-desplegar");
        } else {
            if (scrollY > altoVentana) {
                this.boton.classList.remove("no-desplegar");
            } else {
                this.boton.classList.add("no-desplegar");
            }
        }
    }

    botonClickCallback() {
        return () => {
            const elementoConFocus = document.body.firstElementChild
            window.scrollTo({top: 0, left: 0, behavior: "smooth"});
            document.activeElement.blur();
            if (!!elementoConFocus.hasAttribute("tabindex")) {
                elementoConFocus.focus({preventScroll: true});
            } else {
                elementoConFocus.tabIndex = 0;
                elementoConFocus.focus({preventScroll: true});
                elementoConFocus.removeAttribute("tabindex");
            }
        };
    }

    windowScrollCallback() {
        return () => {
            this.evaluarClaseEnBoton();
        };
    }
}